
import Vue from 'vue'
import { createCallbotCommandKey, createCallbotTelephonyTopup } from '@/api/callbot'
import ZaIcon from './ZaIcon.vue'
import { TELEPHONY_PRESETS, formatRub, parseTopupAmount } from './telephony'

export default Vue.extend({
    name: 'TelephonyTopupDialog',
    components: { ZaIcon },
    props: {
        value: { type: Boolean, default: false },
        projectId: { type: String, required: true },
        balance: { type: Number, default: null },
        // Сумма из расчёта рассылки: подставляется в поле, её можно изменить.
        recommended: { type: Number, default: null },
    },
    data: () => ({
        raw: '',
        busy: false,
        error: '',
        // Один ключ на открытие диалога: двойной клик не создаст два платежа.
        commandKey: createCallbotCommandKey(),
        presets: TELEPHONY_PRESETS,
    }),
    computed: {
        parsed(): { amount: number | null; error: string } {
            return parseTopupAmount(this.raw)
        },
    },
    watch: {
        value(open: boolean) {
            if (!open) return
            this.raw = this.recommended ? String(this.recommended) : ''
            this.error = ''
            this.commandKey = createCallbotCommandKey()
        },
        raw() {
            this.error = ''
        },
    },
    methods: {
        money: formatRub,
        onDialogInput(open: boolean) {
            if (!open) this.close()
        },
        close() {
            if (this.busy) return
            this.$emit('input', false)
        },
        async submit() {
            const amount = this.parsed.amount
            if (amount === null || this.busy) return
            this.busy = true
            // ЮKassa — в новой вкладке, чтобы не потерять незапущенную рассылку.
            // Вкладку открываем сразу по клику: после ответа сервера браузер
            // счёл бы её всплывающим окном и заблокировал.
            const tab = window.open('', '_blank')
            const { data, error } = await createCallbotTelephonyTopup(this.projectId, amount, this.commandKey)
            this.busy = false
            if (error || !data?.confirmationUrl) {
                tab?.close()
                this.error = 'Не удалось создать платёж. Попробуйте ещё раз.'
                return
            }
            if (tab) {
                tab.location.href = data.confirmationUrl
            } else {
                window.open(data.confirmationUrl, '_blank')
            }
            this.$emit('payment-opened', data)
            this.$emit('input', false)
        },
    },
})
